export default __webpack_public_path__ + "static/media/service4.f1aa473b.jpg";